module.exports = __webpack_public_path__ + "static/media/48384989_2308810859194092_7248276848423993344_o-thumb.8ff7ff11.jpg";